// extracted by mini-css-extract-plugin
export default {"backArrow":"render-back_backArrow__4xU-0","closeButtonWrapper":"render-back_closeButtonWrapper__PseoF"};